/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function getStateAbbreviation(name: string): string | null {
    const states: { [key: string]: string } = {
        alabama: 'AL',
        alaska: 'AK',
        arizona: 'AZ',
        arkansas: 'AR',
        california: 'CA',
        colorado: 'CO',
        connecticut: 'CT',
        delaware: 'DE',
        florida: 'FL',
        georgia: 'GA',
        hawaii: 'HI',
        idaho: 'ID',
        illinois: 'IL',
        indiana: 'IN',
        iowa: 'IA',
        kansas: 'KS',
        kentucky: 'KY',
        louisiana: 'LA',
        maine: 'ME',
        maryland: 'MD',
        massachusetts: 'MA',
        michigan: 'MI',
        minnesota: 'MN',
        mississippi: 'MS',
        missouri: 'MO',
        montana: 'MT',
        nebraska: 'NE',
        nevada: 'NV',
        'new hampshire': 'NH',
        'new jersey': 'NJ',
        'new mexico': 'NM',
        'new york': 'NY',
        'north carolina': 'NC',
        'north dakota': 'ND',
        ohio: 'OH',
        oklahoma: 'OK',
        oregon: 'OR',
        pennsylvania: 'PA',
        'rhode island': 'RI',
        'south carolina': 'SC',
        'south dakota': 'SD',
        tennessee: 'TN',
        texas: 'TX',
        utah: 'UT',
        vermont: 'VT',
        virginia: 'VA',
        washington: 'WA',
        'west virginia': 'WV',
        wisconsin: 'WI',
        wyoming: 'WY',
        'district of columbia': 'DC',
        'american samoa': 'AS',
        guam: 'GU',
        'northern mariana islands': 'MP',
        'puerto rico': 'PR',
        'us virgin islands': 'VI',
    };

    const normalized = name.trim().toLowerCase();
    return states[normalized] || null;
}

export function kilometersToMiles(km?: number | string): number | null {
    if (km === undefined || km === null) {
        return null;
    }

    const numericKm = typeof km === 'string' ? parseFloat(km) : km;

    if (Number.isNaN(numericKm)) {
        return null;
    }

    const milesPerKilometer = 0.621371;
    return numericKm * milesPerKilometer;
}
